import { AdvisorModel, ResponseFileModel, Tag } from '@/lib/models';

export enum DOCUMENT_FILE_TYPES {
	VIDEO_LINK = 'VIDEO_LINK',
	XLSX = 'XLSX',
	ZIP = 'ZIP',
	DOCX = 'DOCX',
	TXT = 'TXT',
	PPTX = 'PPTX',
	PDF = 'PDF',
}

export interface ContentType {
	contentTypeId: string;
	count: number;
	description: string;
	name: string;
}

export interface DocumentModel {
	documentId: string;
	relativeUrl: string;
	name: string;
	description?: string;
	content?: string;
	contentDescription?: string;
	listDescription: string;
	documentTypeName: string;
	creatorId?: string;
	topicTags: Tag[];
	publicationDate: string;
	publicationDateDescription: string;
	bookmarkedFlag: boolean;
	fileName?: string;
	fileType?: string;
	viewUrl?: string;
	downloadUrl?: string;
	image?: ResponseFileModel<{ documentAssetId: string; documentId: string }>;
	imageUrl?: string;
	imageType?: string;
	podcastUrl?: string;
	podcastAudioUrl?: string;
	indexUrl?: string;
	displayPodcastPlayer?: boolean;
	canDownload: boolean;
	metaDataOnly?: boolean;
	authors: AdvisorModel[];
	masterClientTags: {
		masterClientId: string;
		programTags: {
			programId: string;
			programName: string;
			topicTags: Tag[];
		}[];
	}[];
	ctaButtonText?: string;
	ctaButtonUrl?: string;
	allowRating?: boolean;
	rating?: RatingModel;
	allowPublicView: boolean;
	allowAiIndexing: boolean;

	contentSourceTypeId: string;
}

export interface TopicTagModel {
	tagId: string;
	name: string;
	tagTypeId: string;
	created: string;
	lastUpdated: string;
}

export interface RatingModel {
	accountId: string;
	averageRating: number;
	blogId: string;
	blogRatingId: string;
	rating: number;
}
